// types
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
  email: "",
  password: "",
  name: "",
  token: "",
  roles: "",
  role_id: "",
  auth: [],
  role_slug: "",
  loginId: null,
  permissions: [],
  portal_access: "",
  bmr_permissions: [],
  bmr_modules: [],
  bmr_submodules: [],
  assignedPIs: [], // Add this for storing PI data
  cr_permissions: []
};

// ==============================|| SLICE - MENU ||============================== //

const LoginData = createSlice({
  name: 'LoginCredentials',
  initialState,
  reducers: {
    loginCredentials(state, action) {
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.token = action.payload.token
      state.roles = action.payload.roles
      state.role_id = action.payload.role_id
      state.role_slug = action.payload.role_slug
      state.auth = action.payload.auth
      state.loginId = action.payload.loginId
      state.permissions = action.payload.permissions
      state.portal_access = action.payload.portal_access
      state.bmr_permissions = action.payload.bmr_permissions
      state.bmr_modules = action.payload.bmr_modules
      state.bmr_submodules = action.payload.bmr_submodules
      state.assignedPIs = action.payload.assignedPIs || [] // Add this line
      state.cr_permissions = action.payload.cr_permissions || [] // Mapping new CR payload
    },
    logoutCredentials(state) {
      state.email = "";
      state.name = "";
      state.token = "";
      state.auth = [];
      state.roles = "";
      state.role_id = "";
      state.permissions = []
      state.portal_access = ''
      state.bmr_permissions = []
      state.bmr_modules = []
      state.bmr_submodules = []
      state.assignedPIs = [] // Add this line
      state.cr_permissions = []
    },
    // Add a new reducer for updating assigned PIs
    updateAssignedPIs(state, action) {
      state.assignedPIs = action.payload;
    }
  }
});

export default LoginData.reducer;

export const { loginCredentials, logoutCredentials, updateAssignedPIs } = LoginData.actions;